// src/components/StatusDropdown.jsx

import React from "react";
import { MenuItem, FormControl, Select, InputLabel } from "@mui/material";

// Updated list of status values matching the database ENUM
const statusOptions = [
  "new",
  "in_triage",
  "blocked",
  "waiting_on_customer",
  "complete",
  "news_releases_and_notices"
];

// Helper to format the label
const formatStatusLabel = (status) => {
  return status
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Dropdown for ticket status.
 * Props:
 * - ticket: the ticket object containing `id` and `status` fields
 * - onChange: function called with the new status value
 */
const StatusDropdown = ({ ticket, onChange }) => {
  if (!ticket) return null;

  const handleChange = (event) => {
    const newStatus = event.target.value;
    onChange && onChange(newStatus);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Status</InputLabel>
      <Select
        value={ticket.status || ""}
        label="Status"
        onChange={handleChange}
      >
        {statusOptions.map((status) => (
          <MenuItem key={status} value={status}>
            {formatStatusLabel(status)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusDropdown;